export const hubsData = {
  hiking: [
    {
      id: "hkg1",
      name: "Chorotagua Iguana Crossing",
      description:
        "Located near and around the river's cannyon, it reaches dolor sit amet, consectetur adipiscing elit. Pellentesque nisl arcu, ullamcorper vitae efficitur id, facilisis et justo. Maecenas ut augue id nibh condimentum hendrerit. Duis lobortis imperdiet augue, sit amet pharetra elit pulvinar id. In finibus vehicula enim, a maximus augue viverra nec. Pellentesque interdum ultrices tortor id finibus. Praesent fringilla elit id arcu facilisis dignissim. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
      length: "4.8km",
      photo: {
        id: "ac683841-9306-48cc-55d5-1c98f05bca00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/ac683841-9306-48cc-55d5-1c98f05bca00/regular",
        orientation: "por",
      },
    },
    {
      id: "hkg2",
      name: "Bijagual Waterfall Trail",
      description:
        "Located near and around the entrance, it reaches Vestibulum consectetur tortor tellus, ut aliquet justo euismod id. In vitae leo orci. Etiam eu leo scelerisque, suscipit turpis eu, sodales ante. Aliquam pellentesque lectus vel pretium faucibus. Pellentesque fringilla ullamcorper gravida. Aenean euismod leo velit, ut pulvinar dolor commodo vel. Donec in consectetur quam, ut gravida nisl. Etiam maximus iaculis lorem tincidunt imperdiet. Vestibulum convallis diam ac enim elementum volutpat. Cras sapien neque, tincidunt ac velit.",
      length: "4.8km",
      photo: {
        id: "9dae3bb5-a686-4aba-1784-213b9f855300",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/9dae3bb5-a686-4aba-1784-213b9f855300/regular",
        orientation: "por",
      },
    },
    {
      id: "hkg3",
      name: "Deep Forest Flare Trail",
      description:
        "Integer consectetur mattis ultricies. Etiam at enim vel nisl cursus maximus et et nulla. Cras pulvinar egestas leo nec commodo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce vehicula, nulla vel semper laoreet, odio arcu sodales tellus, quis rutrum tellus ipsum at est. Fusce pulvinar risus arcu, vel auctor arcu semper sed. Sed non euismod dolor, vitae vulputate libero. Integer sagittis nisi id finibus lobortis. Mauris sit amet luctus leo. Curabitur suscipit suscipit lacus.",
      length: "4.8km",
      photo: {
        id: "0afb8781-7265-4ac8-cceb-3218b8397400",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/0afb8781-7265-4ac8-cceb-3218b8397400/regular",
        orientation: "lan",
      },
    },
    {
      id: "hkg4",
      name: "Fila Verde",
      description:
        "Nunc et ante fermentum, rhoncus orci vitae, aliquam diam. Mauris vitae aliquam ante. Aliquam erat volutpat. Morbi scelerisque maximus augue, sit amet placerat nunc fermentum at. Nunc consequat ante eros, a ornare ipsum viverra ut. Aliquam erat volutpat. Nulla finibus quam orci, sed luctus lectus venenatis ut. Quisque sed feugiat turpis. Etiam in enim est. Phasellus orci dui, luctus sit amet interdum vitae, commodo et velit. Sed porttitor ullamcorper felis non semper. Sed a iaculis lorem. Vestibulum ante ipsum primis.",
      length: "4.8km",
      photo: {
        id: "44444404-d0a8-4209-307f-e1d0577efa00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/44444404-d0a8-4209-307f-e1d0577efa00/regular",
        orientation: "lan",
      },
    },
    {
      id: "hkg5",
      name: "Bajos de la Esperanza",
      description:
        "Suspendisse potenti. Aliquam at lacus blandit, sagittis purus ut, mattis felis. Fusce sollicitudin consequat bibendum. Phasellus non nunc consequat, elementum elit in, imperdiet ante. Ut in enim ligula. Vestibulum id metus vitae tortor pharetra aliquam ut quis ante. Donec nibh arcu, tristique vitae fermentum eget, placerat a augue. Praesent fermentum ultrices augue a bibendum.",
      length: "4.8km",
      photo: {
        id: "43f9d26c-7b0b-4e82-be6a-fc07927c3600",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/43f9d26c-7b0b-4e82-be6a-fc07927c3600/regular",
        orientation: "por",
      },
    },
    {
      id: "hkg6",
      name: "Altos de Fila Negra",
      description:
        "Nunc tempus dolor et malesuada tristique. Praesent eu porttitor ex. Duis porttitor pulvinar auctor. Etiam interdum est orci, quis eleifend massa porta finibus. Morbi nec lacinia turpis, ac porta lectus. Aliquam rhoncus ullamcorper orci ut luctus. Nulla malesuada diam eget sapien laoreet, nec aliquam mauris porta. Suspendisse justo leo, posuere a odio nec, imperdiet fermentum elit. Phasellus accumsan, est vel mollis placerat, nulla mi hendrerit nisl, ac eleifend lectus lectus et diam. Aliquam turpis neque, aliquet ut nibh non, tincidunt.",
      length: "4.8km",
      photo: {
        id: "a6c5e01b-8533-4340-0932-3c6777d14600",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/a6c5e01b-8533-4340-0932-3c6777d14600/regular",
        orientation: "lan",
      },
    },
    {
      id: "hkg7",
      name: "Cruce de los Monos",
      description:
        "Phasellus pretium bibendum odio quis elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec luctus, nisl eget lacinia convallis, lectus turpis iaculis orci, at dictum eros quam sit amet mauris. Proin imperdiet viverra metus in mattis. Suspendisse eu ante hendrerit, varius ante in, molestie mi. Morbi porta est a euismod vulputate. Suspendisse convallis rhoncus pellentesque. Sed id massa non odio auctor imperdiet. Nam hendrerit massa in faucibus tristique. In euismod in tellus quis faucibus.",
      length: "4.8km",
      photo: {
        id: "ecc86a09-8021-4b44-c9d0-3e5701f3b900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/ecc86a09-8021-4b44-c9d0-3e5701f3b900/regular",
        orientation: "por",
      },
    },
    {
      id: "hkg8",
      name: "Deep Rain Forest",
      description:
        "Aenean augue nisi, scelerisque et volutpat non, commodo vitae magna. Donec libero libero, finibus ac nulla sit amet, vestibulum rutrum ligula. Ut faucibus sollicitudin elit, vel volutpat magna ornare vitae. Aenean ultricies fermentum enim in consequat. Vestibulum at tortor iaculis, sodales ex sit amet, efficitur massa. Nulla pulvinar rutrum metus id ultrices. Praesent id turpis eros. Mauris sit amet quam ultricies, dictum elit nec, egestas arcu. Etiam rhoncus libero eu erat lacinia blandit. Nullam lacinia velit elit, a dictum nunc.",
      length: "4.8km",
      photo: {
        id: "871c87b8-4991-487b-f9d2-6993020deb00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/871c87b8-4991-487b-f9d2-6993020deb00/regular",
        orientation: "lan",
      },
    },
    {
      id: "hkg9",
      name: "Cruce de los Trampa",
      description:
        "Aenean laoreet hendrerit finibus. Nunc quam lacus, faucibus vel consequat eu, convallis quis erat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi consequat nisi est, sed lobortis massa tristique ac. Donec dignissim mollis neque a rutrum. Quisque consequat tempus arcu, at condimentum velit. Ut sem nunc, feugiat ac sollicitudin blandit, venenatis vitae tortor. Aenean consectetur, dui malesuada lacinia porta, ligula leo efficitur sapien, vel pharetra velit nulla vitae ligula.",
      length: "4.8km",
      photo: {
        id: "6dd0cdb2-bd73-4fb4-32ed-52cf36ef5300",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/6dd0cdb2-bd73-4fb4-32ed-52cf36ef5300/regular",
        orientation: "por",
      },
    },
  ],
  waterfalls: [
    {
      id: "wfl1",
      name: "Catarata Río Celeste",
      description:
        "Located near and around the river's cannyon, it reaches dolor sit amet, consectetur adipiscing elit. Pellentesque nisl arcu, ullamcorper vitae efficitur id, facilisis et justo. Maecenas ut augue id nibh condimentum hendrerit. Duis lobortis imperdiet augue, sit amet pharetra elit pulvinar id. In finibus vehicula enim, a maximus augue viverra nec. Pellentesque interdum ultrices tortor id finibus. Praesent fringilla elit id arcu facilisis dignissim. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
      height: "25m",
      photo: {
        id: "b4aac62d-fce7-4781-7b8c-e0f822849400",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/b4aac62d-fce7-4781-7b8c-e0f822849400/regular",
        orientation: "lan",
      },
    },
    {
      id: "wfl2",
      name: "La Esperanza Waterfall",
      description:
        "Located near and around the entrance, it reaches Vestibulum consectetur tortor tellus, ut aliquet justo euismod id. In vitae leo orci. Etiam eu leo scelerisque, suscipit turpis eu, sodales ante. Aliquam pellentesque lectus vel pretium faucibus. Pellentesque fringilla ullamcorper gravida. Aenean euismod leo velit, ut pulvinar dolor commodo vel. Donec in consectetur quam, ut gravida nisl. Etiam maximus iaculis lorem tincidunt imperdiet. Vestibulum convallis diam ac enim elementum volutpat. Cras sapien neque, tincidunt ac velit.",
      height: "18m",
      photo: {
        id: "3e964807-18c8-4998-1299-3a8abb207100",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/3e964807-18c8-4998-1299-3a8abb207100/regular",
        orientation: "por",
      },
    },
    {
      id: "wfl3",
      name: "Deep Forest Flare Creek",
      description:
        "Integer consectetur mattis ultricies. Etiam at enim vel nisl cursus maximus et et nulla. Cras pulvinar egestas leo nec commodo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce vehicula, nulla vel semper laoreet, odio arcu sodales tellus, quis rutrum tellus ipsum at est. Fusce pulvinar risus arcu, vel auctor arcu semper sed. Sed non euismod dolor, vitae vulputate libero. Integer sagittis nisi id finibus lobortis. Mauris sit amet luctus leo. Curabitur suscipit suscipit lacus.",
      height: "8m",
      photo: {
        id: "a40a188b-efe0-4c93-4b74-b14a0fcc8600",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/a40a188b-efe0-4c93-4b74-b14a0fcc8600/regular",
        orientation: "por",
      },
    },
    {
      id: "wfl4",
      name: "Fila Verde",
      description:
        "Nunc et ante fermentum, rhoncus orci vitae, aliquam diam. Mauris vitae aliquam ante. Aliquam erat volutpat. Morbi scelerisque maximus augue, sit amet placerat nunc fermentum at. Nunc consequat ante eros, a ornare ipsum viverra ut. Aliquam erat volutpat. Nulla finibus quam orci, sed luctus lectus venenatis ut. Quisque sed feugiat turpis. Etiam in enim est. Phasellus orci dui, luctus sit amet interdum vitae, commodo et velit. Sed porttitor ullamcorper felis non semper. Sed a iaculis lorem. Vestibulum ante ipsum primis.",
      height: "8m",
      photo: {
        id: "3e316723-9187-4e31-be34-4902ab684900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/3e316723-9187-4e31-be34-4902ab684900/regular",
        orientation: "lan",
      },
    },
    {
      id: "wfl5",
      name: "Bajos de la Esperanza",
      description:
        "Suspendisse potenti. Aliquam at lacus blandit, sagittis purus ut, mattis felis. Fusce sollicitudin consequat bibendum. Phasellus non nunc consequat, elementum elit in, imperdiet ante. Ut in enim ligula. Vestibulum id metus vitae tortor pharetra aliquam ut quis ante. Donec nibh arcu, tristique vitae fermentum eget, placerat a augue. Praesent fermentum ultrices augue a bibendum.",
      height: "48m",
      photo: {
        id: "b267e46a-231c-48ca-d0b5-5918514e4700",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/b267e46a-231c-48ca-d0b5-5918514e4700/regular",
        orientation: "por",
      },
    },
    {
      id: "wfl6",
      name: "Catarata Bijagualito",
      description:
        "Nunc tempus dolor et malesuada tristique. Praesent eu porttitor ex. Duis porttitor pulvinar auctor. Etiam interdum est orci, quis eleifend massa porta finibus. Morbi nec lacinia turpis, ac porta lectus. Aliquam rhoncus ullamcorper orci ut luctus. Nulla malesuada diam eget sapien laoreet, nec aliquam mauris porta. Suspendisse justo leo, posuere a odio nec, imperdiet fermentum elit. Phasellus accumsan, est vel mollis placerat, nulla mi hendrerit nisl, ac eleifend lectus lectus et diam. Aliquam turpis neque, aliquet ut nibh non, tincidunt.",
      height: "80m",
      photo: {
        id: "6e429f67-37f9-4c7a-5bc2-9c45828eb300",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/6e429f67-37f9-4c7a-5bc2-9c45828eb300/regular",
        orientation: "por",
      },
    },
    {
      id: "wfl7",
      name: "Cruce de los Monos",
      description:
        "Phasellus pretium bibendum odio quis elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec luctus, nisl eget lacinia convallis, lectus turpis iaculis orci, at dictum eros quam sit amet mauris. Proin imperdiet viverra metus in mattis. Suspendisse eu ante hendrerit, varius ante in, molestie mi. Morbi porta est a euismod vulputate. Suspendisse convallis rhoncus pellentesque. Sed id massa non odio auctor imperdiet. Nam hendrerit massa in faucibus tristique. In euismod in tellus quis faucibus.",
      height: "4m",
      photo: {
        id: "8336e788-57a7-42e7-6c61-780252442000",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/8336e788-57a7-42e7-6c61-780252442000/regular",
        orientation: "lan",
      },
    },
    {
      id: "wfl8",
      name: "Deep Rain Waterfall",
      description:
        "Aenean augue nisi, scelerisque et volutpat non, commodo vitae magna. Donec libero libero, finibus ac nulla sit amet, vestibulum rutrum ligula. Ut faucibus sollicitudin elit, vel volutpat magna ornare vitae. Aenean ultricies fermentum enim in consequat. Vestibulum at tortor iaculis, sodales ex sit amet, efficitur massa. Nulla pulvinar rutrum metus id ultrices. Praesent id turpis eros. Mauris sit amet quam ultricies, dictum elit nec, egestas arcu. Etiam rhoncus libero eu erat lacinia blandit. Nullam lacinia velit elit, a dictum nunc.",
      height: "50m",
      photo: {
        id: "1505e7f5-dae8-44e2-ce69-4be50d5fd900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/1505e7f5-dae8-44e2-ce69-4be50d5fd900/regular",
        orientation: "por",
      },
    },
    {
      id: "wfl9",
      name: "Cañón de la Trampa",
      description:
        "Aenean laoreet hendrerit finibus. Nunc quam lacus, faucibus vel consequat eu, convallis quis erat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi consequat nisi est, sed lobortis massa tristique ac. Donec dignissim mollis neque a rutrum. Quisque consequat tempus arcu, at condimentum velit. Ut sem nunc, feugiat ac sollicitudin blandit, venenatis vitae tortor. Aenean consectetur, dui malesuada lacinia porta, ligula leo efficitur sapien, vel pharetra velit nulla vitae ligula.",
      height: "12m",
      photo: {
        id: "038075a6-2137-4af0-4284-72f0230af700",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/038075a6-2137-4af0-4284-72f0230af700/regular",
        orientation: "lan",
      },
    },
  ],
  lodging: [
    {
      id: "ldg1",
      name: "Paradise View Hotel",
      description:
        "Located near and around the river's cannyon, it reaches dolor sit amet, consectetur adipiscing elit. Pellentesque nisl arcu, ullamcorper vitae efficitur id, facilisis et justo. Maecenas ut augue id nibh condimentum hendrerit. Duis lobortis imperdiet augue, sit amet pharetra elit pulvinar id. In finibus vehicula enim, a maximus augue viverra nec. Pellentesque interdum ultrices tortor id finibus. Praesent fringilla elit id arcu facilisis dignissim. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
      photo: {
        id: "37fa942f-aa24-44b8-5ddd-68fe23d4d000",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/37fa942f-aa24-44b8-5ddd-68fe23d4d000/regular",
        orientation: "lan",
      },
    },
    {
      id: "ldg2",
      name: "Hotel Cabo La Esperanza",
      description:
        "Located near and around the entrance, it reaches Vestibulum consectetur tortor tellus, ut aliquet justo euismod id. In vitae leo orci. Etiam eu leo scelerisque, suscipit turpis eu, sodales ante. Aliquam pellentesque lectus vel pretium faucibus. Pellentesque fringilla ullamcorper gravida. Aenean euismod leo velit, ut pulvinar dolor commodo vel. Donec in consectetur quam, ut gravida nisl. Etiam maximus iaculis lorem tincidunt imperdiet. Vestibulum convallis diam ac enim elementum volutpat. Cras sapien neque, tincidunt ac velit.",
      photo: {
        id: "64eed36d-af36-4267-b296-56f2771a7d00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/64eed36d-af36-4267-b296-56f2771a7d00/regular",
        orientation: "lan",
      },
    },
    {
      id: "ldg3",
      name: "Sunrise Cabins",
      description:
        "Integer consectetur mattis ultricies. Etiam at enim vel nisl cursus maximus et et nulla. Cras pulvinar egestas leo nec commodo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce vehicula, nulla vel semper laoreet, odio arcu sodales tellus, quis rutrum tellus ipsum at est. Fusce pulvinar risus arcu, vel auctor arcu semper sed. Sed non euismod dolor, vitae vulputate libero. Integer sagittis nisi id finibus lobortis. Mauris sit amet luctus leo. Curabitur suscipit suscipit lacus.",
      photo: {
        id: "d17a46b2-80ad-4f3f-4115-ba0d1ccecd00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/d17a46b2-80ad-4f3f-4115-ba0d1ccecd00/regular",
        orientation: "por",
      },
    },
    {
      id: "ldg4",
      name: "Mi Sueño Hotel and Casino",
      description:
        "Nunc et ante fermentum, rhoncus orci vitae, aliquam diam. Mauris vitae aliquam ante. Aliquam erat volutpat. Morbi scelerisque maximus augue, sit amet placerat nunc fermentum at. Nunc consequat ante eros, a ornare ipsum viverra ut. Aliquam erat volutpat. Nulla finibus quam orci, sed luctus lectus venenatis ut. Quisque sed feugiat turpis. Etiam in enim est. Phasellus orci dui, luctus sit amet interdum vitae, commodo et velit. Sed porttitor ullamcorper felis non semper. Sed a iaculis lorem. Vestibulum ante ipsum primis.",
      photo: {
        id: "df4ed66e-e7c2-497a-2390-f0b207e53300",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/df4ed66e-e7c2-497a-2390-f0b207e53300/regular",
        orientation: "por",
      },
    },
    {
      id: "ldg5",
      name: "Hotel Los Tucanes",
      description:
        "Suspendisse potenti. Aliquam at lacus blandit, sagittis purus ut, mattis felis. Fusce sollicitudin consequat bibendum. Phasellus non nunc consequat, elementum elit in, imperdiet ante. Ut in enim ligula. Vestibulum id metus vitae tortor pharetra aliquam ut quis ante. Donec nibh arcu, tristique vitae fermentum eget, placerat a augue. Praesent fermentum ultrices augue a bibendum.",
      photo: {
        id: "b23697cd-cce0-4a3c-7849-eeb3c317d900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/b23697cd-cce0-4a3c-7849-eeb3c317d900/regular",
        orientation: "lan",
      },
    },
    {
      id: "ldg6",
      name: "Cabinas La Cangreja",
      description:
        "Nunc tempus dolor et malesuada tristique. Praesent eu porttitor ex. Duis porttitor pulvinar auctor. Etiam interdum est orci, quis eleifend massa porta finibus. Morbi nec lacinia turpis, ac porta lectus. Aliquam rhoncus ullamcorper orci ut luctus. Nulla malesuada diam eget sapien laoreet, nec aliquam mauris porta. Suspendisse justo leo, posuere a odio nec, imperdiet fermentum elit. Phasellus accumsan, est vel mollis placerat, nulla mi hendrerit nisl, ac eleifend lectus lectus et diam. Aliquam turpis neque, aliquet ut nibh non, tincidunt.",
      photo: {
        id: "dd7d8e99-598e-4c61-6c15-7abdb1cd6100",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/dd7d8e99-598e-4c61-6c15-7abdb1cd6100/regular",
        orientation: "lan",
      },
    },
    {
      id: "ldg7",
      name: "Cabinas Lajas",
      description:
        "Phasellus pretium bibendum odio quis elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec luctus, nisl eget lacinia convallis, lectus turpis iaculis orci, at dictum eros quam sit amet mauris. Proin imperdiet viverra metus in mattis. Suspendisse eu ante hendrerit, varius ante in, molestie mi. Morbi porta est a euismod vulputate. Suspendisse convallis rhoncus pellentesque. Sed id massa non odio auctor imperdiet. Nam hendrerit massa in faucibus tristique. In euismod in tellus quis faucibus.",
      photo: {
        id: "fbb82f9a-0e39-4991-bab8-942ea6f9b500",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/fbb82f9a-0e39-4991-bab8-942ea6f9b500/regular",
        orientation: "lan",
      },
    },
    {
      id: "ldg8",
      name: "Aguacate Mountain Retreat ",
      description:
        "Aenean augue nisi, scelerisque et volutpat non, commodo vitae magna. Donec libero libero, finibus ac nulla sit amet, vestibulum rutrum ligula. Ut faucibus sollicitudin elit, vel volutpat magna ornare vitae. Aenean ultricies fermentum enim in consequat. Vestibulum at tortor iaculis, sodales ex sit amet, efficitur massa. Nulla pulvinar rutrum metus id ultrices. Praesent id turpis eros. Mauris sit amet quam ultricies, dictum elit nec, egestas arcu. Etiam rhoncus libero eu erat lacinia blandit. Nullam lacinia velit elit, a dictum nunc.",
      photo: {
        id: "a41b3789-9065-44da-1941-f142fb8cbf00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/a41b3789-9065-44da-1941-f142fb8cbf00/regular",
        orientation: "por",
      },
    },
    {
      id: "ldg9",
      name: "Hotel Casi Cielo",
      description:
        "Aenean laoreet hendrerit finibus. Nunc quam lacus, faucibus vel consequat eu, convallis quis erat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi consequat nisi est, sed lobortis massa tristique ac. Donec dignissim mollis neque a rutrum. Quisque consequat tempus arcu, at condimentum velit. Ut sem nunc, feugiat ac sollicitudin blandit, venenatis vitae tortor. Aenean consectetur, dui malesuada lacinia porta, ligula leo efficitur sapien, vel pharetra velit nulla vitae ligula.",
      photo: {
        id: "83a7f05a-344b-4f12-b3b8-67b987b84f00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/83a7f05a-344b-4f12-b3b8-67b987b84f00/regular",
        orientation: "lan",
      },
    },
  ],
  restaurants: [
    {
      id: "rest1",
      name: "Nuestra Tierra",
      description:
        "Located near and around the river's cannyon, it reaches dolor sit amet, consectetur adipiscing elit. Pellentesque nisl arcu, ullamcorper vitae efficitur id, facilisis et justo. Maecenas ut augue id nibh condimentum hendrerit. Duis lobortis imperdiet augue, sit amet pharetra elit pulvinar id. In finibus vehicula enim, a maximus augue viverra nec. Pellentesque interdum ultrices tortor id finibus. Praesent fringilla elit id arcu facilisis dignissim. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
      photo: {
        id: "6c239359-b1b0-475c-2872-1d6fc3efe800",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/6c239359-b1b0-475c-2872-1d6fc3efe800/regular",
        orientation: "lan",
      },
    },
    {
      id: "rest2",
      name: "La Esperanza Argentina",
      description:
        "Located near and around the entrance, it reaches Vestibulum consectetur tortor tellus, ut aliquet justo euismod id. In vitae leo orci. Etiam eu leo scelerisque, suscipit turpis eu, sodales ante. Aliquam pellentesque lectus vel pretium faucibus. Pellentesque fringilla ullamcorper gravida. Aenean euismod leo velit, ut pulvinar dolor commodo vel. Donec in consectetur quam, ut gravida nisl. Etiam maximus iaculis lorem tincidunt imperdiet. Vestibulum convallis diam ac enim elementum volutpat. Cras sapien neque, tincidunt ac velit.",
      photo: {
        id: "2c4eb9e8-522c-4456-f520-75293bd0bb00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/2c4eb9e8-522c-4456-f520-75293bd0bb00/regular",
        orientation: "por",
      },
    },
    {
      id: "rest3",
      name: "Tamales Típicos",
      description:
        "Integer consectetur mattis ultricies. Etiam at enim vel nisl cursus maximus et et nulla. Cras pulvinar egestas leo nec commodo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce vehicula, nulla vel semper laoreet, odio arcu sodales tellus, quis rutrum tellus ipsum at est. Fusce pulvinar risus arcu, vel auctor arcu semper sed. Sed non euismod dolor, vitae vulputate libero. Integer sagittis nisi id finibus lobortis. Mauris sit amet luctus leo. Curabitur suscipit suscipit lacus.",
      photo: {
        id: "df9cc6a3-ef66-4227-2cef-496a7b7d0d00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/df9cc6a3-ef66-4227-2cef-496a7b7d0d00/regular",
        orientation: "lan",
      },
    },
    {
      id: "rest4",
      name: "Farmer's Market",
      description:
        "Nunc et ante fermentum, rhoncus orci vitae, aliquam diam. Mauris vitae aliquam ante. Aliquam erat volutpat. Morbi scelerisque maximus augue, sit amet placerat nunc fermentum at. Nunc consequat ante eros, a ornare ipsum viverra ut. Aliquam erat volutpat. Nulla finibus quam orci, sed luctus lectus venenatis ut. Quisque sed feugiat turpis. Etiam in enim est. Phasellus orci dui, luctus sit amet interdum vitae, commodo et velit. Sed porttitor ullamcorper felis non semper. Sed a iaculis lorem. Vestibulum ante ipsum primis.",
      photo: {
        id: "6ffeaa7e-5ef4-4f4a-33d9-38285c8c0200",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/6ffeaa7e-5ef4-4f4a-33d9-38285c8c0200/regular",
        orientation: "por",
      },
    },
    {
      id: "rest5",
      name: "Pin-Tico",
      description:
        "Suspendisse potenti. Aliquam at lacus blandit, sagittis purus ut, mattis felis. Fusce sollicitudin consequat bibendum. Phasellus non nunc consequat, elementum elit in, imperdiet ante. Ut in enim ligula. Vestibulum id metus vitae tortor pharetra aliquam ut quis ante. Donec nibh arcu, tristique vitae fermentum eget, placerat a augue. Praesent fermentum ultrices augue a bibendum.",
      photo: {
        id: "8dbbebc6-e909-4657-74b1-44cbd6515f00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/8dbbebc6-e909-4657-74b1-44cbd6515f00/regular",
        orientation: "lan",
      },
    },
    {
      id: "rest6",
      name: "Flory's Corner",
      description:
        "Nunc tempus dolor et malesuada tristique. Praesent eu porttitor ex. Duis porttitor pulvinar auctor. Etiam interdum est orci, quis eleifend massa porta finibus. Morbi nec lacinia turpis, ac porta lectus. Aliquam rhoncus ullamcorper orci ut luctus. Nulla malesuada diam eget sapien laoreet, nec aliquam mauris porta. Suspendisse justo leo, posuere a odio nec, imperdiet fermentum elit. Phasellus accumsan, est vel mollis placerat, nulla mi hendrerit nisl, ac eleifend lectus lectus et diam. Aliquam turpis neque, aliquet ut nibh non, tincidunt.",
      photo: {
        id: "7104aa7d-a2a2-4d01-b461-2737b901b900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/7104aa7d-a2a2-4d01-b461-2737b901b900/regular",
        orientation: "lan",
      },
    },
    {
      id: "rest7",
      name: "Hannia's Place",
      description:
        "Phasellus pretium bibendum odio quis elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec luctus, nisl eget lacinia convallis, lectus turpis iaculis orci, at dictum eros quam sit amet mauris. Proin imperdiet viverra metus in mattis. Suspendisse eu ante hendrerit, varius ante in, molestie mi. Morbi porta est a euismod vulputate. Suspendisse convallis rhoncus pellentesque. Sed id massa non odio auctor imperdiet. Nam hendrerit massa in faucibus tristique. In euismod in tellus quis faucibus.",
      photo: {
        id: "f37e7621-0913-424b-3b5b-6066cd9ac800",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/f37e7621-0913-424b-3b5b-6066cd9ac800/regular",
        orientation: "lan",
      },
    },
    {
      id: "rest8",
      name: "El Aguacate",
      description:
        "Aenean augue nisi, scelerisque et volutpat non, commodo vitae magna. Donec libero libero, finibus ac nulla sit amet, vestibulum rutrum ligula. Ut faucibus sollicitudin elit, vel volutpat magna ornare vitae. Aenean ultricies fermentum enim in consequat. Vestibulum at tortor iaculis, sodales ex sit amet, efficitur massa. Nulla pulvinar rutrum metus id ultrices. Praesent id turpis eros. Mauris sit amet quam ultricies, dictum elit nec, egestas arcu. Etiam rhoncus libero eu erat lacinia blandit. Nullam lacinia velit elit, a dictum nunc.",
      photo: {
        id: "8ac1c063-6758-475e-1372-49d8c30e4e00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/8ac1c063-6758-475e-1372-49d8c30e4e00/regular",
        orientation: "por",
      },
    },
    {
      id: "rest9",
      name: "Lajas RestoBar",
      description:
        "Aenean laoreet hendrerit finibus. Nunc quam lacus, faucibus vel consequat eu, convallis quis erat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi consequat nisi est, sed lobortis massa tristique ac. Donec dignissim mollis neque a rutrum. Quisque consequat tempus arcu, at condimentum velit. Ut sem nunc, feugiat ac sollicitudin blandit, venenatis vitae tortor. Aenean consectetur, dui malesuada lacinia porta, ligula leo efficitur sapien, vel pharetra velit nulla vitae ligula.",
      photo: {
        id: "c0ed8b5d-fcb3-4fdf-e5fd-1a1fcee6b100",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/c0ed8b5d-fcb3-4fdf-e5fd-1a1fcee6b100/regular",
        orientation: "lan",
      },
    },
  ],
  tours: [
    {
      id: "trs1",
      name: "Wildlife Observatory Institute",
      description:
        "Located near and around the river's cannyon, it reaches dolor sit amet, consectetur adipiscing elit. Pellentesque nisl arcu, ullamcorper vitae efficitur id, facilisis et justo. Maecenas ut augue id nibh condimentum hendrerit. Duis lobortis imperdiet augue, sit amet pharetra elit pulvinar id. In finibus vehicula enim, a maximus augue viverra nec. Pellentesque interdum ultrices tortor id finibus. Praesent fringilla elit id arcu facilisis dignissim. Interdum et malesuada fames ac ante ipsum primis in faucibus.",
      photo: {
        id: "8c9e1774-868b-4567-6011-63a787f74100",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/8c9e1774-868b-4567-6011-63a787f74100/regular",
        orientation: "por",
      },
    },
    {
      id: "trs2",
      name: "Surfing Classes",
      description:
        "Located near and around the entrance, it reaches Vestibulum consectetur tortor tellus, ut aliquet justo euismod id. In vitae leo orci. Etiam eu leo scelerisque, suscipit turpis eu, sodales ante. Aliquam pellentesque lectus vel pretium faucibus. Pellentesque fringilla ullamcorper gravida. Aenean euismod leo velit, ut pulvinar dolor commodo vel. Donec in consectetur quam, ut gravida nisl. Etiam maximus iaculis lorem tincidunt imperdiet. Vestibulum convallis diam ac enim elementum volutpat. Cras sapien neque, tincidunt ac velit.",
      photo: {
        id: "720d0f1b-30df-4876-bbfc-7915b5731000",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/720d0f1b-30df-4876-bbfc-7915b5731000/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs3",
      name: "Organic Avocado Farm Tour",
      description:
        "Integer consectetur mattis ultricies. Etiam at enim vel nisl cursus maximus et et nulla. Cras pulvinar egestas leo nec commodo. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce vehicula, nulla vel semper laoreet, odio arcu sodales tellus, quis rutrum tellus ipsum at est. Fusce pulvinar risus arcu, vel auctor arcu semper sed. Sed non euismod dolor, vitae vulputate libero. Integer sagittis nisi id finibus lobortis. Mauris sit amet luctus leo. Curabitur suscipit suscipit lacus.",
      photo: {
        id: "7f0ffef0-8ee3-4da6-4c41-4c37d3062400",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/7f0ffef0-8ee3-4da6-4c41-4c37d3062400/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs4",
      name: "Coffee Farm Tour",
      description:
        "Nunc et ante fermentum, rhoncus orci vitae, aliquam diam. Mauris vitae aliquam ante. Aliquam erat volutpat. Morbi scelerisque maximus augue, sit amet placerat nunc fermentum at. Nunc consequat ante eros, a ornare ipsum viverra ut. Aliquam erat volutpat. Nulla finibus quam orci, sed luctus lectus venenatis ut. Quisque sed feugiat turpis. Etiam in enim est. Phasellus orci dui, luctus sit amet interdum vitae, commodo et velit. Sed porttitor ullamcorper felis non semper. Sed a iaculis lorem. Vestibulum ante ipsum primis.",
      photo: {
        id: "c5fee3ff-3cda-4633-744a-fcc66e158d00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/c5fee3ff-3cda-4633-744a-fcc66e158d00/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs5",
      name: "Camping in La Cangreja",
      description:
        "Suspendisse potenti. Aliquam at lacus blandit, sagittis purus ut, mattis felis. Fusce sollicitudin consequat bibendum. Phasellus non nunc consequat, elementum elit in, imperdiet ante. Ut in enim ligula. Vestibulum id metus vitae tortor pharetra aliquam ut quis ante. Donec nibh arcu, tristique vitae fermentum eget, placerat a augue. Praesent fermentum ultrices augue a bibendum.",
      photo: {
        id: "8b3a1192-d907-466d-b92c-b049cf4bdb00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/8b3a1192-d907-466d-b92c-b049cf4bdb00/regular",
        orientation: "por",
      },
    },
    {
      id: "trs6",
      name: "Yoga by the Beach",
      description:
        "Nunc tempus dolor et malesuada tristique. Praesent eu porttitor ex. Duis porttitor pulvinar auctor. Etiam interdum est orci, quis eleifend massa porta finibus. Morbi nec lacinia turpis, ac porta lectus. Aliquam rhoncus ullamcorper orci ut luctus. Nulla malesuada diam eget sapien laoreet, nec aliquam mauris porta. Suspendisse justo leo, posuere a odio nec, imperdiet fermentum elit. Phasellus accumsan, est vel mollis placerat, nulla mi hendrerit nisl, ac eleifend lectus lectus et diam. Aliquam turpis neque, aliquet ut nibh non, tincidunt.",
      photo: {
        id: "59575da4-7734-4a48-8934-70b99d0cb100",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/59575da4-7734-4a48-8934-70b99d0cb100/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs7",
      name: "Horseback on the Beach",
      description:
        "Phasellus pretium bibendum odio quis elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Donec luctus, nisl eget lacinia convallis, lectus turpis iaculis orci, at dictum eros quam sit amet mauris. Proin imperdiet viverra metus in mattis. Suspendisse eu ante hendrerit, varius ante in, molestie mi. Morbi porta est a euismod vulputate. Suspendisse convallis rhoncus pellentesque. Sed id massa non odio auctor imperdiet. Nam hendrerit massa in faucibus tristique. In euismod in tellus quis faucibus.",
      photo: {
        id: "7b1de0e7-681a-4732-23b2-7575a0970900",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/7b1de0e7-681a-4732-23b2-7575a0970900/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs8",
      name: "Organic Beam Farm Walk",
      description:
        "Aenean augue nisi, scelerisque et volutpat non, commodo vitae magna. Donec libero libero, finibus ac nulla sit amet, vestibulum rutrum ligula. Ut faucibus sollicitudin elit, vel volutpat magna ornare vitae. Aenean ultricies fermentum enim in consequat. Vestibulum at tortor iaculis, sodales ex sit amet, efficitur massa. Nulla pulvinar rutrum metus id ultrices. Praesent id turpis eros. Mauris sit amet quam ultricies, dictum elit nec, egestas arcu. Etiam rhoncus libero eu erat lacinia blandit. Nullam lacinia velit elit, a dictum nunc.",
      photo: {
        id: "39d3a84c-fdd4-444c-a062-c60968108b00",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/39d3a84c-fdd4-444c-a062-c60968108b00/regular",
        orientation: "lan",
      },
    },
    {
      id: "trs9",
      name: "Butterfly Farm Tour",
      description:
        "Aenean laoreet hendrerit finibus. Nunc quam lacus, faucibus vel consequat eu, convallis quis erat. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Morbi consequat nisi est, sed lobortis massa tristique ac. Donec dignissim mollis neque a rutrum. Quisque consequat tempus arcu, at condimentum velit. Ut sem nunc, feugiat ac sollicitudin blandit, venenatis vitae tortor. Aenean consectetur, dui malesuada lacinia porta, ligula leo efficitur sapien, vel pharetra velit nulla vitae ligula.",
      photo: {
        id: "23b044e6-930c-4fc3-8f2a-fd2004ba4000",
        url: "https://imagedelivery.net/KuVp-L0ue-dbspqdyuGkJw/23b044e6-930c-4fc3-8f2a-fd2004ba4000/regular",
        orientation: "lan",
      },
    },
  ],
};
